import { Envelope, MapPin, Phone } from '@phosphor-icons/react';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { ContactForm } from '../components/ContactForm';
import { Reveal } from '../components/Reveal';
import { business } from '../content/site';

export function Contact() {
  return (
    <>
      <section className="contact-hero section-shell">
        <Breadcrumbs items={[{ label: 'Request an Estimate' }]} />
        <div className="contact-hero__grid">
          <Reveal><p className="section-kicker">Start with the property</p><h1>Tell us about the work.</h1><p>Share the location, the service, and what you have noticed. Your details stay in the form if delivery fails.</p></Reveal>
          <Reveal className="contact-direct" delay={0.08}>
            <a href={business.phoneHref}><Phone aria-hidden="true" size={21} weight="fill" /><span>Call</span><strong>{business.phoneDisplay}</strong></a>
            <a href={business.emailHref}><Envelope aria-hidden="true" size={21} /><span>Email</span><strong>{business.email}</strong></a>
            <div><MapPin aria-hidden="true" size={21} weight="fill" /><span>Base</span><strong>{business.base}</strong></div>
          </Reveal>
        </div>
      </section>
      <section className="contact-section section-pad section-shell">
        <Reveal><ContactForm /></Reveal>
        <aside className="contact-aside">
          <Reveal><h2>Helpful details</h2><ul><li>Property city or ZIP code</li><li>Desired materials, colors, or finish</li><li>Approximate dimensions and how you want to use the space</li><li>Inspiration for the finished project</li><li>What changed and when you noticed it, if repairs are needed</li><li>Access, water, or drainage concerns</li><li>Your preferred timeframe</li></ul></Reveal>
          <Reveal delay={0.08}><h2>What happens next</h2><p>Your information is reviewed so the next conversation can focus on the site, the scope, and whether an on-site look makes sense.</p></Reveal>
        </aside>
      </section>
    </>
  );
}
